import type { ReactElement } from 'react';
import { NewsletterSources } from './NewsletterSources.tsx';
import './inbox.css';

export const INBOX_SHORTCUTS: [string, string][] = [
  ['g then e', 'Go to Newsletter sources'],
  ['1 / 2 / 3', 'Newsletters: Senders, Mails, Offers found'],
];

export function inboxPage(path: string): ReactElement | null {
  return path === '/newsletters' ? <NewsletterSources /> : null;
}
